"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchDriftPriorityFee = void 0;
const node_fetch_1 = __importDefault(require("node-fetch"));
async function fetchDriftPriorityFee(url, marketTypes, marketIndexes) {
    try {
        const response = await (0, node_fetch_1.default)(`${url}/batchPriorityFees?marketType=${marketTypes.join(',')}&marketIndex=${marketIndexes.join(',')}`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    }
    catch (err) {
        if (err instanceof Error) {
            console.error('Error fetching priority fees:', err.message);
        }
        else {
            console.error('Unknown error fetching priority fees:', err);
        }
    }
    return [];
}
exports.fetchDriftPriorityFee = fetchDriftPriorityFee;
